import { render, staticRenderFns } from "./PartyWork.vue?vue&type=template&id=84e0fd46&scoped=true&"
import script from "./PartyWork.vue?vue&type=script&lang=js&"
export * from "./PartyWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e0fd46",
  null
  
)

export default component.exports